<script setup lang="ts">
const { disabled = false } = defineProps<{
  disabled?: boolean;
}>();
</script>

<template>
  <fieldset class="form-fieldset" :disabled="disabled">
    <slot />
  </fieldset>
</template>

<style lang="scss" scoped>
.form-fieldset {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  border: none;
  padding: 0;
}
</style>
